import { render, staticRenderFns } from "./FormulasCalculo.vue?vue&type=template&id=ba12fcfa&scoped=true"
import script from "./FormulasCalculo.vue?vue&type=script&lang=js"
export * from "./FormulasCalculo.vue?vue&type=script&lang=js"
import style0 from "./FormulasCalculo.vue?vue&type=style&index=0&id=ba12fcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba12fcfa",
  null
  
)

export default component.exports